/* global Hammer */

(function($) {
    'use strict';
    var Carousel = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$slidesContainer = this.$el.find('.carousel-item-container');
        this.$slides = this.$slidesContainer.children();
        this.$controls = null;
        this.$leftArrow = null;
        this.$rightArrow = null;
        this.changingSlide = false;
        this.transitionType = this.$el.is('.carousel-transition-type-slide')
            ? 'slide'
            : 'fade';
        this.slideSpeed = 1200;
        this.slideEasing = 'swing';
        this.slideOffset = 60;
        this.fadeInSpeed = 700;
        this.fadeOutSpeed = 300;
        this.autoPlay = this.$el.is('.carousel-autoplay');
        this.autoPlayTimer = null;
        this.autoPlayDelay = 6500;
        this.animateSwipe = this.$el.is('.carousel-controls-swipe-animate');
        this.init();
    };
    Carousel.prototype = {
        movingArrow: false,
        init: function() {
            this.setUp();
            this.bindEvents();
            this.startAutoPlay();
        },
        bindEvents: function() {
            var that = this;
            if (this.$slides.size() <= 1) {
                $('.carousel-controls').hide();
            }
            if (this.$slides.size() > 1) {
                this.$rightArrow.on('click', function() {
                    that.goRight();
                });
                this.$leftArrow.on('click', function() {
                    that.goLeft();
                });
                if (typeof Hammer !== 'undefined') {
                    var hammertime = new Hammer(that.$el.get(0));
                    hammertime.on('swipeleft', function() {
                        if (that.animateSwipe) {
                            that.$rightArrow.addClass('show');
                            setTimeout(function() {
                                that.$rightArrow.removeClass('show');
                                that.goLeft();
                            }, 600);
                        } else {
                            that.goLeft();
                        }
                    });
                    hammertime.on('swiperight', function() {
                        if (that.animateSwipe) {
                            that.$leftArrow.addClass('show');
                            setTimeout(function() {
                                that.$leftArrow.removeClass('show');
                                that.goRight();
                            }, 600);
                        } else {
                            that.goRight();
                        }
                    });
                }
                if (this.$pager) {
                    this.$pager.on('click', 'li', function() {
                        that.changeTo($(this).index());
                    });
                }
            }
            $(window).resize(function() {
                that.setCarouselHeight();
            });
            $(window).on('breakpoint.changed', function() {
                if (!$.breakpoint.size('<', 'sm')) {
                    that.startAutoPlay();
                }
                if ($.breakpoint.size('==', 'xxs')) {
                    that.mobileArrows();
                } else if ($.breakpoint.size('>', 'xxs')) {
                    that.$leftArrow.removeAttr('style');
                    that.$rightArrow.removeAttr('style');
                }
            });
        },
        mobileArrows: function() {
            var that = this,
                wait = 600,
                delay = 400;
            if (!that.animateSwipe) {
                return;
            }
            setTimeout(function() {
                that.$leftArrow.addClass('show');
                that.$rightArrow.addClass('show');
                setTimeout(function() {
                    that.$leftArrow.removeClass('show');
                    that.$rightArrow.removeClass('show');
                }, delay + wait);
            }, wait);
        },
        setUp: function() {
            this.initializeElements();
            if (this.$slides.size() > 1) {
                $.each(this.$slides, function(index, slide) {
                    if (index === 0) {
                        $(slide).css({ position: 'relative' });
                    } else {
                        $(slide).css({ position: 'absolute' });
                    }
                });
                this.$controls.append(this.$leftArrow, this.$rightArrow, this.$pager);
                this.$controls.insertAfter(this.$slidesContainer);
            }
        },
        initializeElements: function() {
            this.setCarouselHeight();
            this.$controls = this.getEl('carousel-controls');
            this.$leftArrow = this.getEl('carousel-go-left');
            this.$leftArrow.append('<i class="icon-carousel-left" />');
            this.$rightArrow = this.getEl('carousel-go-right');
            this.$rightArrow.append('<i class="icon-carousel-right" />');
            if (!this.$el.is('.no-pager')) {
                this.$pager = this.getEl('carousel-pager', 'ul');
                this.$pager
                    .append(
                        new Array(this.$slides.size() + 1).join(
                            '<li><i class="icon-carousel-control-indicator" /></li>'
                        )
                    )
                    .children()
                    .first()
                    .addClass('active');
            }
        },
        startAutoPlay: function() {
            if (this.autoPlay && this.$slides.size() > 1) {
                this.runAutoPlay();
            }
        },
        runAutoPlay: function() {
            var that = this;
            clearTimeout(this.autoPlayTimer);
            this.autoPlayTimer = setTimeout(function() {
                that.goRight();
                that.runAutoPlay();
            }, this.autoPlayDelay);
        },
        stopAutoPlay: function() {
            clearTimeout(this.autoPlayTimer);
        },
        isAttached: function($el) {
            return $el.closest(document.documentElement);
        },
        getEl: function(className, nodeType) {
            var $el = this.$el.find('.' + className);
            nodeType = nodeType || 'div';
            if (!$el.size()) {
                $el = $('<' + nodeType + ' class="' + className + '" />');
            }

            return $el;
        },
        getCurrentSlide: function() {
            var $current = this.$slides.filter('.current');
            if (!$current.size()) {
                $current = this.$slides.eq(0).addClass('current');
            }

            return $current;
        },
        getNextSlide: function(direction) {
            var $current = this.getCurrentSlide(),
                $next;
            if (direction === 'left') {
                $next = $current.prev();
                if (!$next.size()) {
                    $next = this.$slides.eq(-1);
                }
            } else {
                $next = $current.next();
                if (!$next.size()) {
                    $next = this.$slides.eq(0);
                }
            }

            return $next;
        },
        slide: function(direction) {
            if (this.changingSlide) {
                return;
            }
            var that = this,
                $currentSlide = this.getCurrentSlide(),
                $nextSlide = this.getNextSlide(direction),
                currentStartPosition,
                nextStartPosition,
                currentEndPosition,
                nextEndPosition;
            currentStartPosition = 0;
            if (direction === 'right') {
                currentEndPosition = -$currentSlide.width() - this.slideOffset;
                nextStartPosition = $currentSlide.width() + this.slideOffset;
                nextEndPosition = 0;
            } else {
                currentEndPosition = $currentSlide.width() + this.slideOffset;
                nextStartPosition = -$currentSlide.width() - this.slideOffset;
                nextEndPosition = 0;
            }
            this.changeSlideStart();
            $currentSlide
                .css({
                    left: currentStartPosition
                })
                .velocity(
                    {
                        left: currentEndPosition
                    },
                    {
                        duration: this.slideSpeed,
                        easing: this.slideEasing,
                        queue: false,
                        complete: function() {
                            $currentSlide.removeClass('current').hide();
                            that.changeSlideEnd();
                        }
                    }
                );
            $nextSlide
                .show()
                .css({
                    left: nextStartPosition,
                    opacity: 1
                })
                .velocity(
                    {
                        left: nextEndPosition
                    },
                    {
                        duration: this.slideSpeed,
                        easing: this.slideEasing,
                        queue: false,
                        complete: function() {
                            $nextSlide.addClass('current');
                            that.slideEnd();
                        }
                    }
                );
            this.updatePager($nextSlide.index());

            return false;
        },
        changeTo: function(index) {
            var $currentSlide = this.getCurrentSlide(),
                $nextSlide = this.$slides.eq(index);
            this.$slidesContainer.height($nextSlide.height());
            this.$slides.css({ opacity: 1, left: 0 }).fadeOut(this.fadeOutSpeed);
            $currentSlide.removeClass('current');
            $nextSlide.addClass('current');
            $nextSlide.css({ left: 0 }).stop(true, true).fadeIn(this.fadeInSpeed);
            this.updatePager(index);
        },
        goRight: function() {
            var $nextSlide = this.getNextSlide('right');
            if (this.transitionType === 'fade') {
                this.changeTo($nextSlide.index());
            } else if (this.transitionType === 'slide') {
                this.slide('right');
            }
        },
        goLeft: function() {
            var $nextSlide = this.getNextSlide('left');
            if (this.transitionType === 'fade') {
                this.changeTo($nextSlide.index());
            } else if (this.transitionType === 'slide') {
                this.slide('left');
            }
        },
        changeSlideStart: function() {
            this.changingSlide = true;
            this.$el.addClass('changing-slide');
        },
        changeSlideEnd: function() {
            this.changingSlide = false;
            this.$el.removeClass('changing-slide');
        },
        updatePager: function(index) {
            if (this.$pager) {
                this.$pager.find('li').removeClass('active').eq(index).addClass('active');
            }
        },
        setCarouselHeight: function() {
            var $currentSlide = this.getCurrentSlide(),
                $images = $currentSlide.find('img'),
                $image,
                height = $currentSlide.height();
            $images.each(function() {
                $image = $(this);
                if ($image.height() > height) {
                    height = $image.height();
                }
            });
            this.$slidesContainer.height('auto');
            this.$slidesContainer.css('height', height);
        }
    };
    $.fn.carousel = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('carousel');
            if (!data) {
                $this.data('carousel', (data = new Carousel(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.carousel.Constructor = Carousel;
})(jQuery);
